import { Route } from '@angular/router';
import { AgreementsComponent } from './containers/agreements/agreements.component';
import { DashboardComponent } from './containers/dashboard/dashboard.component';
import { DashboardHomeComponent } from './containers/home/dashboard.component';
import { MetricsComponent } from './containers/metrics/metrics.component';
import { MoreComponent } from './containers/more/more.component';

export const ROUTES: Route[] = [
  {
    path: '',
    component: DashboardHomeComponent,
    children: [
      { path: 'overview', component: DashboardComponent },
      {
        path: 'agreements',
        component: AgreementsComponent,
      },
      {
        path: 'metrics',
        component: MetricsComponent,
      },
      {
        path: 'companies',
        component: AgreementsComponent,
      },
      {
        path: 'more',
        component: MoreComponent,
      },
      { path: '', redirectTo: 'overview', pathMatch: 'full' },
    ],
  },
];
